<template>
    <div>
        <span>{{text}}</span>
    </div>
</template>

<script>
export default {
    name: 'SubjectText',

    data() {
        return {
            
        };
    },
    props: [ 'text' ],
};
</script>

<style lang="scss" scoped>
    
</style>